export const IMAGE_MIME_TYPES = ["image/jpeg", "image/png"];

export const ALLOWED_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
];

export const ALLOWED_ACCEPT = ALLOWED_EXTENSIONS.join(",");

export const SUPPORTED_FORMATS_LABEL = "PDF, DOC, DOCX, TXT, JPG, PNG";
